import { plainToInstance } from 'class-transformer';
import { getHeaders } from '../../util/http-utils';
import { apiClientFactory } from '../../common/clients';
import { ViewStoreStatusDto } from './dto/view-store-status.dto';
import { UpdateStoreStatusFeatureNoteDto } from './dto/update-store-status-feature-note.dto';

const apiClient = apiClientFactory();

/****************************
Store
****************************/

const resource = 'store';

export enum StoreQueryKeys {
  'findStatus' = 'FindStatus',
}

export async function getStoreStatus(): Promise<ViewStoreStatusDto> {
  const { data } = await apiClient.get(`v1/${resource}/status`, {
    headers: getHeaders(),
  });

  return plainToInstance(ViewStoreStatusDto, data, {
    excludeExtraneousValues: true,
  });
}

export async function updateStoreStatusFeatureNote(
  updateStoreStatusFeatureNoteDto: UpdateStoreStatusFeatureNoteDto,
): Promise<ViewStoreStatusDto> {
  const { data } = await apiClient.patch(
    `v1/${resource}/status`,
    updateStoreStatusFeatureNoteDto,
    {
      headers: getHeaders(),
    },
  );

  return plainToInstance(ViewStoreStatusDto, data, {
    excludeExtraneousValues: true,
  });
}
